import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../SectionTitle';
import getTabData from '../../lib/tab-data';
import './tab.scss';
import TablatureList from './TablatureList';
import { filterByType } from '../../utils/tabs-utils';

export class Tabs extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tabsList: [],
    };
  }

  componentDidMount() {
    const { tabs } = this.props;
    if (!tabs) {
      return;
    }
    this.loadTabs();
  }

  componentDidUpdate(prevProps) {
    const { tabs } = this.props;
    const tabFile = tabs[0] ? tabs[0]['tab-file'] : null;
    const prevTabFile = prevProps.tabs[0] ? prevProps.tabs[0]['tab-file'] : null;
    if (tabFile !== prevTabFile) {
      this.loadTabs();
    }
  }

  async loadTabs() {
    const { tabs, type } = this.props;
    const filteredList = filterByType(tabs, type);
    const tabsList = filteredList.map(async tab => {
      const tabData = await getTabData(tab['tab-file']);
      return { type: 'xml', data: tabData };
    });
    Promise.all(tabsList).then(loadedTabsList => {
      this.setState({ tabsList: loadedTabsList });
    });
  }

  render() {
    const { settings, title, isFullScreen, toggleFullScreen } = this.props;
    const { tabsList } = this.state;
    if (!tabsList || !tabsList.length) {
      return null;
    }
    return (
      <div className="tablature relative">
        {title ? <SectionTitle title={title} /> : null}
        <TablatureList
          tabsList={tabsList}
          settings={settings}
          isFullScreen={isFullScreen}
          toggleFullScreen={toggleFullScreen}
        />
      </div>
    );
  }
}

Tabs.propTypes = {
  settings: PropTypes.shape({}),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      'tab-file': PropTypes.string,
      'tab-title': PropTypes.string,
      'tab-type': PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  type: PropTypes.string,
  isFullScreen: PropTypes.bool,
  toggleFullScreen: PropTypes.func,
};

Tabs.defaultProps = {
  settings: null,
  tabs: null,
  title: null,
  type: null,
  isFullScreen: false,
  toggleFullScreen: () => {},
};

export default Tabs;
